import React from 'react';
import AnalyticsImage from '../assets/chart_stock_image.jpg'; // Import the new image

const Analytics = () => {
  return (
    <div className='w-full bg-white dark:bg-[#0A1220] py-16 px-4 border-b border-gray-200 dark:border-gray-800 relative overflow-hidden transition-colors duration-300'>
      {/* Background Glow */}
      <div className='absolute top-0 right-0 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-3xl'></div>

      <div className='max-w-[1240px] mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10'>

        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-emerald-600 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
          <img
            className='relative w-full rounded-lg shadow-2xl object-cover border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900'
            src={AnalyticsImage}
            alt='Data Analytics Dashboard'
          />
        </div>

        {/* Text Section */}
        <div className='flex flex-col justify-center'>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-[1px] bg-blue-500"></span>
            <p className='text-blue-500 font-mono text-sm tracking-widest uppercase'>Why DataHelix?</p>
          </div>

          <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold py-2 text-gray-900 dark:text-white leading-tight'>
            Bridge the gap between
            <br />
            <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400'>Theory & Real-World Impact</span>
          </h1>

          <p className='text-gray-600 dark:text-gray-400 leading-relaxed text-lg mt-6'>
            Most courses teach syntax. We teach <span className="text-gray-900 dark:text-gray-200 font-medium">problem solving</span>.
            Guided by real-world case studies, our platform equips you with both the technical SQL skills and the business acumen needed to answer the questions that actually matter.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4">
            <div className="border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900/50 p-4 rounded-lg">
              <h3 className="text-gray-900 dark:text-white font-bold text-lg mb-1">100+</h3>
              <p className="text-gray-600 dark:text-gray-500 text-sm">Real-World Challenges</p>
            </div>
            <div className="border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900/50 p-4 rounded-lg">
              <h3 className="text-gray-900 dark:text-white font-bold text-lg mb-1">Zero</h3>
              <p className="text-gray-600 dark:text-gray-500 text-sm">Setup Required</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
